export const SET_MESSAGE_NOTIFICATION = 'SET_MESSAGE_NOTIFICATION';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const GET_NOTIFICATION = 'GET_NOTIFICATION'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS'